module.exports = __webpack_public_path__ + "static/media/registericon.db8c0d36.svg";